import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.navigation');
import { OnInit, OnDestroy, HostListener, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-component-navigation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.navigation/view.scss */
:host {
  display: block;
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-container {
  width: 100%;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(228, 228, 231, 0.6);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.nav-container.scrolled {
  height: 64px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
}
.nav-container.transparent {
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border-bottom-color: transparent;
}
.nav-container.transparent .nav-link {
  color: #fff;
}
.nav-container.transparent .nav-link:hover {
  color: rgba(255, 255, 255, 0.8);
}
.nav-container.transparent .nav-link.active {
  color: #fff;
}
.nav-container.transparent .nav-link.active::after {
  background: #fff;
}
.nav-container.transparent .lang-btn {
  color: rgba(255, 255, 255, 0.6);
}
.nav-container.transparent .lang-btn.active {
  color: #fff;
}
.nav-container.transparent .lang-divider {
  color: rgba(255, 255, 255, 0.3);
}
.nav-container.transparent .logo-dark {
  display: none;
}
.nav-container.transparent .logo-light {
  display: block;
}
@media (max-width: 768px) {
  .nav-container {
    height: 64px;
  }
  .nav-container.scrolled {
    height: 56px;
  }
}

.nav-inner {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
@media (max-width: 1024px) {
  .nav-inner {
    padding: 0 20px;
  }
}

.nav-logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
}
.nav-logo img {
  height: 28px;
  transition: opacity 0.2s ease;
}
.nav-logo .logo-light {
  display: none;
}
.nav-logo:hover img {
  opacity: 0.8;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 4px;
}
@media (max-width: 768px) {
  .nav-menu {
    display: none;
  }
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  font-size: 17px;
  font-weight: 500;
  color: #3f3f46;
  text-decoration: none;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.nav-link:hover {
  color: #18181b;
  background: rgba(244, 244, 245, 0.8);
}
.nav-link.active {
  color: #18181b;
  font-weight: 600;
}
.nav-link.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  height: 2px;
  background: #FE5A33;
  border-radius: 1px;
  animation: underline-in 0.3s ease forwards;
}

@keyframes underline-in {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
.nav-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.lang-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
}
@media (max-width: 768px) {
  .lang-toggle {
    display: none;
  }
}

.lang-btn {
  background: none;
  border: none;
  padding: 4px 2px;
  font-size: 17px;
  font-weight: 600;
  color: #a1a1aa;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0;
}
.lang-btn:hover {
  color: #52525b;
}
.lang-btn.active {
  color: #18181b;
}

.lang-divider {
  font-size: 17px;
  color: #d4d4d8;
  user-select: none;
}

.nav-cta {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #FE5A33, #FF8A65);
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.nav-cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(254, 90, 51, 0.3);
}
.nav-cta:active {
  transform: translateY(0);
}
@media (max-width: 768px) {
  .nav-cta {
    display: none;
  }
}

.nav-hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease;
}
.nav-hamburger:hover {
  background: rgba(244, 244, 245, 0.8);
}
@media (max-width: 768px) {
  .nav-hamburger {
    display: flex;
  }
}

.hamburger-line {
  width: 20px;
  height: 2px;
  background: #18181b;
  border-radius: 1px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.transparent .hamburger-line {
  background: #fff;
}
.hamburger-line.open:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.hamburger-line.open:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}
.hamburger-line.open:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(12, 10, 9, 0.97);
  z-index: 200;
  display: flex;
  flex-direction: column;
  opacity: 0;
  visibility: hidden;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.mobile-overlay.open {
  opacity: 1;
  visibility: visible;
}

.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  height: 64px;
}
.mobile-header .nav-logo .logo-dark {
  display: none;
}
.mobile-header .nav-logo .logo-light {
  display: block;
}

.mobile-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease;
}
.mobile-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.mobile-menu {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
  overflow-y: auto;
}

.mobile-link {
  display: block;
  padding: 16px 0;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: color 0.2s ease;
}
.mobile-link:hover {
  color: #FE5A33;
}

.mobile-footer {
  padding: 24px 32px;
}

.mobile-lang {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-lang-btn {
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: color 0.2s ease;
  letter-spacing: 0;
}
.mobile-lang-btn:hover {
  color: rgba(255, 255, 255, 0.7);
}
.mobile-lang-btn.active {
  color: #fff;
}

.mobile-lang-divider {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.2);
  user-select: none;
}

@media (prefers-reduced-motion: reduce) {
  .nav-container,
  .mobile-overlay,
  .hamburger-line,
  .nav-link::after {
    transition: none;
    animation: none;
  }
}`],
})
export class ComponentNavigationComponent implements OnInit, OnDestroy {
    @Input() transparent: boolean = false;
    @Input() scrolled: boolean = false;

    public isMobileOpen: boolean = false;
    public currentPath: string = '';

    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {}

    public async ngOnInit() {
        await this.service.init();
        this.currentPath = location.pathname;

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.currentPath = event.urlAfterRedirects || event.url;
                this.isMobileOpen = false;
                await this.service.render();
            }
        });

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.isMobileOpen) {
            document.body.style.overflow = '';
        }
    }

    @HostListener('document:keydown.escape')
    onEscape() {
        if (this.isMobileOpen) {
            this.closeMobile();
        }
    }

    public isActive(path: string): boolean {
        return this.currentPath.indexOf(path) === 0;
    }

    public toggleMobile() {
        this.isMobileOpen = !this.isMobileOpen;
        document.body.style.overflow = this.isMobileOpen ? 'hidden' : '';
        this.service.render();
    }

    public closeMobile() {
        this.isMobileOpen = false;
        document.body.style.overflow = '';
        this.service.render();
    }

    public async switchLanguage(lang: string) {
        await this.service.lang.set(lang);
        await this.service.render();
    }

    public navigate(path: string) {
        this.closeMobile();
        this.service.href(path);
    }

    public get currentLang(): string {
        try {
            return this.service.lang.get() || 'en';
        } catch {
            return 'en';
        }
    }
}

export default ComponentNavigationComponent;